import React, { createContext, useState } from "react";
import SpinHeros from "../img/Spin Heros/SpinHeroes.jpg"
import SpaceSaberPic from "../img/Space Saber/SpaceSaber.png"
import FlyGuy from "../img/FlyGuy/FlyGuy.png";
import TrainLikeMasterAppIcon from "../img/TrainLikeMaster/AppIcon.jpg"

import ButtonRush from "../img/ButtonRush/ButtonRush.png";
import ButtonRush1 from "../img/ButtonRush/pic1.jpg";
import ButtonRush2 from "../img/ButtonRush/pic2.jpg";
import ButtonRush3 from "../img/ButtonRush/pic3.jpg";
import ButtonRush4 from "../img/ButtonRush/pic4.jpg";
import ButtonRush5 from "../img/ButtonRush/pic5.jpg";
import ButtonRush6 from "../img/ButtonRush/pic6.jpg";

import FlyGuy1 from "../img/FlyGuy/pic1.jpg";
import FlyGuy2 from "../img/FlyGuy/pic2.jpg"
import FlyGuy3 from "../img/FlyGuy/pic3.jpg"
import FlyGuy4 from "../img/FlyGuy/pic4.jpg"
import FlyGuy5 from "../img/FlyGuy/pic5.jpg"

import SpaceSaber1 from "../img/Space Saber/pic1.jpg";
import SpaceSaber2 from "../img/Space Saber/pic2.jpg";
import SpaceSaber3 from "../img/Space Saber/pic3.jpg";
import SpaceSaber4 from "../img/Space Saber/pic4.jpg";
import SpaceSaber5 from "../img/Space Saber/pic5.jpg";
import SpaceSaber6 from "../img/Space Saber/pic6.jpg";

import SpinHeros1 from "../img/Spin Heros/pic1.jpg";
import SpinHeros2 from "../img/Spin Heros/pic2.jpg";
import SpinHeros3 from "../img/Spin Heros/pic3.jpg";
import SpinHeros4 from "../img/Spin Heros/pic4.jpg";
import SpinHeros5 from "../img/Spin Heros/pic5.jpg";
import SpinHeros6 from "../img/Spin Heros/pic6.jpg";
import SpinHeros7 from "../img/Spin Heros/pic7.jpg";

import TrainLikeMaster1 from "../img/TrainLikeMaster/pic1.jpg";
import TrainLikeMaster2 from "../img/TrainLikeMaster/pic2.jpg"
import TrainLikeMaster3 from "../img/TrainLikeMaster/pic3.jpg"
import TrainLikeMaster4 from "../img/TrainLikeMaster/pic4.jpg"
import TrainLikeMaster5 from "../img/TrainLikeMaster/pic5.jpg"

export const StateContext = createContext();

const StateContextP = (props) => {
  const [gameInfo] = useState([
    {
      img: SpinHeros,
      gameTitle: "Spin Heroes",
      gameDescription:
        "Spin Heroes, a captivating casual casino mobile game with a superhero twist! Dive into an engaging world where you can construct and defend your very own village while indulging in the excitement of spinning the fortune wheel.",
      genre: "Casino, Arcade, Adventure",
      engine: "Unity",
      platform: "Android",
      screenshots: [
        SpinHeros1,
        SpinHeros2,
        SpinHeros3,
        SpinHeros4,
        SpinHeros5,
        SpinHeros6,
        SpinHeros7,
      ],
      videoUrl: "https://www.youtube.com/embed/7OEoDubGaVk"
      // link: "https://bit.ly/3fNQlNw",
    },
    {
      img: TrainLikeMasterAppIcon,
      gameTitle: "Train Like Master",
      gameDescription:
        "Introducing Master's Reflex, an exhilarating mobile game that puts your reflexes and decision-making abilities to the test in a variety of captivating 3D environments. Assume the role of a wise Kung Fu master and delve into a realm where precision and concentration are essential for success.",
      genre: "Casino, Arcade, Adventure",
      engine: "Unity",
      platform: "Android",
      screenshots: [
        TrainLikeMaster1,
        TrainLikeMaster2,
        TrainLikeMaster3,
        TrainLikeMaster4,
        TrainLikeMaster5,
      ],
      videoUrl: "https://www.youtube.com/embed/9q_H0HvZuhs"
    },
    {
      img: SpaceSaberPic,
      gameTitle: "Space Saber",
      gameDescription:
        "Space Saber, an exhilarating mobile game inspired by the popular VR game Beat Saber. Immerse yourself in a galactic adventure where precision, timing, and quick reflexes are crucial to success",
      genre: "Arcade, Action, Rytem",
      engine: "Unity",
      platform: "Android",
      screenshots: [
        SpaceSaber1,
        SpaceSaber2,
        SpaceSaber3,
        SpaceSaber4,
        SpaceSaber5,
        SpaceSaber6
      ],
      videoUrl: "https://www.youtube.com/embed/enSxfyU8uS8"
      // link: "https://bit.ly/3MreCp8",
    },
    {
      img: ButtonRush,
      gameTitle: "Button Rush",
      gameDescription: "Button-Rush is a mobile puzzle game with over 20 unique levels, the player must press all the buttons in the room before time runs out!",
      genre: "Puzzle",
      engine: "Unity",
      platform: "Android",
      screenshots: [
        ButtonRush1,
        ButtonRush2,
        ButtonRush3,
        ButtonRush4,
        ButtonRush5,
        ButtonRush6
      ],
      videoUrl: "https://www.youtube.com/embed/l9JSjJHM2_g"
      // link: "https://bit.ly/3fZB2kS",
    },
    {
      img: FlyGuy,
      gameTitle: "FlyGuy",
      gameDescription: "FlyGuy is a mobile action/runner game, the player goal is to reach up as high as possible and collect as much coins as they can.",
      genre: "Action, Runner",
      engine: "Unity",
      platform: "Android",
      screenshots: [
        FlyGuy1,
        FlyGuy2,
        FlyGuy3,
        FlyGuy4,
        FlyGuy5
      ],
      videoUrl: "https://www.youtube.com/embed/uJh-MTg242k"
      // link: "https://bit.ly/3CslXzR",
    },
  ]);

  const [webInfo] = useState([
    // {
    //   img: IceAndBellPic,
    //   projectTitle: "Ice And Bell",
    //   projectDescription:
    //     "Landing page that made for a tictok content creator that have over 56k followers.",
    //   languages: "HTML5, CSS, JavaScript(ES6)",
    //   frameworks: "React.js",
    // },
    // {
    //   img: bookFinderPic,
    //   projectTitle: "Book Finder",
    //   projectDescription:
    //     "React Web-Application with Google's book API, You can find any book that you like.",
    //   languages: "HTML5, CSS, JavaScript(ES6)",
    //   frameworks: "React.js",
    // },

    // {
    //   img: WeatherAppPic,
    //   projectTitle: "Weather App",
    //   projectDescription:
    //     "Weather Web-Application with Accuweather's API, You can search any city in the world with auto search, And add your favorite city to your personal list.",
    //   languages: "HTML5, CSS, JavaScript(ES6)",
    //   frameworks: "React.js",
    // },
  ]);

  return (
    <StateContext.Provider value={{ gameInfo, webInfo }}>
      {props.children}
    </StateContext.Provider>
  );
};

export default StateContextP;
